export const BAC_ACTIVITIES_MAIN_DATA = [
  {
    title: {
      ar: 'النشاط الفني (الموسيقى والرسم)',
      en: 'Art (Music & Drawing)',
      fr: 'Art (Musique & Dessin)',
    },
    description: {
      ar: `عندما يجتمع الرسم والموسيقى!
 ""الموسيقى هي فن الأصوات، والرسم هو فن الألوان، لكن لا يوجد فن بدون مشاعر.""، جيوم أبولينير، شاعر وكاتب فرنسي ، 1880-1918`,
      fr: `Quand les arts plastiques et la musique se conjuguent !« La musique est l'art des sons, la peinture est l'art des couleurs, mais il n'y a pas d'art sans émotion. » Guillaume Apollinaire, poète et écrivain français (1880-1918)`,
      en: `When drawing and music come together!
 ""Music is the art of sounds, painting is the art of colors, but there is no art without emotion.""
 Guillaume Apollinaire, a French poet and writer (1880-1918)`,
    },
    order: 3,
    attachments: [], // TODO : Attach art.jpg,
    link: 'activities/art',
    image: 'art.jpg',
    type: 'activities',
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط الرياضي',
      fr: 'Sport',
      en: 'Sport',
    },
    description: {
      ar: `""الرياضة تعطي للجسد ما تعطيه القراءة للعقل.""
 فرانسوا-رينيه دي شاتوبريان، كاتب فرنسي (1768-1848)`,
      fr: `"Le sport donne au corps ce que la lecture donne à l’esprit.", François-René de Chateaubriand, écrivain français (1768-1848)`,
      en: `""Sport gives to the body what reading gives to the mind.""
 François-René de Chateaubriand, French writer (1768-1848)`,
    },
    order: 2,
    attachments: [], // TODO : attach sport.png
    image: 'sport.png',
    link: 'activities/sports',
    type: 'activities',
    isArchived: false,
  },
  {
    title: {
      ar: 'النشاط المسرحي',
      fr: 'Théâtre',
      en: 'Theatre',
    },
    description: {
      ar: `
 القرن السابع عشر
 " المسرح ليس سوى مكان للعرض. "
 موليير، أعظم كتّاب المسرح الفرنسي، 1622 - 1673`,
      fr: `"Le théâtre n'est fait que pour être vu", Molière, le plus grand dramaturge français (1622 – 1673).`,
      en: `17th century:"The theater is made only to be seen."
 (Molière, the greatest French playwright, 1622–1673)`,
    },
    order: 3,
    attachments: [], //TODO: Attach 'theatre.png'
    image: 'theatre.png',
    link: 'activities/theatre',
    type: 'activities',
    isArchived: false,
  },
];
